var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 223.2 77.9",
    width: 232.2,
    height: 77.9,
    style: {
      enableBackground: "new 0 0 223.2 77.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(140.509997, 195.72526)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-84.6-169.4c1.8,0,3.6,0.4,5.3,1.1c1.8,0.7,3.2,1.7,4.5,3l-3.6,4.2c-0.8-1-1.7-1.7-2.8-2.3 c-1.1-0.6-2.2-0.9-3.3-0.9c-1.9,0-3.5,0.7-4.8,2c-1.3,1.3-1.9,3-1.9,5c0,2,0.6,3.7,1.9,5.1c1.3,1.4,2.9,2,4.8,2 c1,0,2.1-0.2,3.2-0.8c1.1-0.5,2.1-1.2,2.9-2.1l3.6,3.8c-1.3,1.3-2.9,2.4-4.7,3.2c-1.8,0.8-3.6,1.2-5.4,1.2 c-3.7,0-6.7-1.2-9.1-3.6c-2.4-2.4-3.6-5.3-3.6-8.9c0-3.5,1.2-6.4,3.7-8.8C-91.4-168.2-88.3-169.4-84.6-169.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.496606, 195.72526)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-73.9-149.4h-10.6l-1.8,4.5h-6.3l10.5-24.3h6.4l10.2,24.3h-6.6L-73.9-149.4z M-75.7-154l-3.5-9l-3.5,9 H-75.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(178.510605, 195.72526)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-64.8-164.2h-7.3v19.3h-6.2v-19.3h-7.2v-5h20.7V-164.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.391845, 195.72526)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-69.4-159.3l1.1,0.2c1.8,0.3,3.3,1,4.4,2.1c1.1,1.2,1.6,2.6,1.6,4.5c0,2.3-0.9,4.2-2.6,5.7 c-1.7,1.5-3.9,2.2-6.7,2.2c-1.6,0-3.3-0.3-4.9-0.8c-1.6-0.5-3-1.2-4.1-2.1l2.5-4.7c1.8,2,3.9,3,6.1,3c1.2,0,2.1-0.3,2.8-0.8 c0.7-0.6,1-1.3,1-2.3c0-2-1.3-3-3.8-3h-3.9v-3.3l5.4-5.6h-8.8v-4.7h16v3.5L-69.4-159.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.895502, 195.72526)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-63-169.4c3,0,5.6,0.7,7.8,2l-2.4,4.3c-1.4-1-3.1-1.6-5.1-1.6c-1.9,0-3.3,0.6-4.3,1.7 c-1,1.1-1.4,2.7-1.4,4.7c1.2-1.7,3.2-2.6,5.8-2.6c2.4,0,4.3,0.7,5.7,2.1c1.4,1.4,2.1,3.3,2.1,5.7c0,2.6-0.8,4.6-2.5,6.1 c-1.7,1.5-3.9,2.3-6.6,2.3c-3.3,0-5.8-1.1-7.7-3.2c-1.9-2.2-2.8-5.1-2.8-8.9c0-3.9,1-6.9,3-9.3C-69.1-168.3-66.4-169.4-63-169.4 z M-63.9-156.3c-1.2,0-2.1,0.3-2.8,0.9c-0.7,0.6-1,1.4-1,2.5c0,1,0.3,1.8,0.9,2.4c0.6,0.6,1.5,1,2.7,1c1.1,0,2-0.3,2.6-0.9 c0.6-0.6,1-1.5,1-2.6c0-1-0.3-1.8-0.9-2.4C-61.9-156-62.7-156.3-63.9-156.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(225.322579, 195.72526)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-57.9-169.4c3.4,0,6.1,1.1,7.9,3.2c1.8,2.1,2.8,5.2,2.8,9.1c0,4-0.9,7-2.8,9.1c-1.8,2.1-4.5,3.2-7.9,3.2 c-3.5,0-6.1-1.1-8-3.2c-1.9-2.1-2.8-5.2-2.8-9.1c0-4,0.9-7,2.8-9.1C-64.1-168.3-61.4-169.4-57.9-169.4z M-57.9-164.9 c-1.6,0-2.7,0.6-3.4,1.8c-0.7,1.2-1,3.2-1,6c0,2.8,0.3,4.8,1,6c0.7,1.2,1.8,1.8,3.4,1.8c1.5,0,2.6-0.6,3.3-1.9 c0.7-1.2,1.1-3.2,1.1-6s-0.4-4.7-1.1-6C-55.3-164.2-56.4-164.9-57.9-164.9z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,77.4h222"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.2,0.5h222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.4b49beed2eded33a9fca2dc54f70fae4.svg";
export { ForwardRef as ReactComponent };